import { z } from 'zod';
/** A spot on the map, in degrees. */
export const PointSchema = z.object({ lat: z.number().min(-90).max(90), lng: z.number().min(-180).max(180) });
/** Where an address is, when it came from a suggestion or the phone's location; a typed address has none. */
export const optionalPoint = PointSchema.nullable().optional();
/** The point stored in two columns, or null when either is missing. */
export const pointOf = (lat, lng) => lat == null || lng == null ? null : { lat, lng };
/** Decodes an encoded polyline; the route service uses precision 6. */
export function decodePolyline(encoded, precision = 6) {
    const factor = 10 ** precision;
    const out = [];
    let index = 0;
    let lat = 0;
    let lng = 0;
    const delta = () => {
        let result = 0;
        let shift = 0;
        let byte;
        do {
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);
        return result & 1 ? ~(result >> 1) : result >> 1;
    };
    while (index < encoded.length) {
        lat += delta();
        lng += delta();
        out.push({ lat: lat / factor, lng: lng / factor });
    }
    return out;
}
/** Turn-by-turn to an address in the driver's own navigation app; the point, when known, avoids a wrong match. */
export function directionsLinks(address, point) {
    const q = encodeURIComponent(address);
    const at = point ? `${point.lat},${point.lng}` : null;
    return {
        apple: `https://maps.apple.com/?daddr=${at ?? q}${at ? `&q=${q}` : ''}`,
        google: `https://www.google.com/maps/dir/?api=1&destination=${at ?? q}`,
        waze: at ? `https://waze.com/ul?ll=${at}&navigate=yes` : `https://waze.com/ul?q=${q}&navigate=yes`,
    };
}
//# sourceMappingURL=geo.js.map